import { Grid, Skeleton } from '@mui/material';

export default function TableSkeletonContainer({
  rowLength,
  headerLength
}: {
  rowLength: number;
  headerLength: number;
}) {
  let count = 0;
  let headerCount = 0;
  const listOfRowSkeleton = [];
  const listOfCells = [];
  const listOfHeaderSkeleton = [];
  let noOfCells = 0;

  while (noOfCells < 12) {
    noOfCells++;
    listOfCells.push(
      <Grid key={noOfCells} item lg={1} md={1} xs={1}>
        <Skeleton variant='rectangular' style={{ width: '100%' }} height={30} />
      </Grid>
    );
  }

  while (headerCount < headerLength) {
    headerCount++;
    listOfHeaderSkeleton.push(
      <Grid key={headerCount} item lg={2} md={2} xs={2}>
        <Skeleton variant='rectangular' style={{ width: '100%' }} height={60} />
      </Grid>
    );
  }

  // Preparing skeleton for table rows
  while (count <= rowLength) {
    count++;
    listOfRowSkeleton.push(
      <Grid key={count} className='filter-container' container alignItems='center'>
        <Grid
          item
          container
          spacing={1}
          xs
          justifyContent='stretch'
          style={{ marginTop: '3px' }}
        >
          {listOfCells}
        </Grid>
      </Grid>
    );
  }
  return (
    <div>
      {/* Preparing skeleton for table headers */}
      <Grid className='filter-container' container alignItems='center'>
        <Grid item container spacing={1} xs justifyContent='stretch'>
          {listOfHeaderSkeleton}
        </Grid>
      </Grid>
      {listOfRowSkeleton}
    </div>
  );
}
